module.exports = __webpack_public_path__ + "static/media/ME_climbing_anim.9cbed27a.mp4";